export default __webpack_public_path__ + "static/media/slice-slides.9e3633a1.jpg";